import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwPill from "@components/shared/OwPill/OwPill";
import IOrder from "@models/IOrder";
import RmaService from "@services/RmaService";
import { Link } from "react-router-dom";

type Props = {
    order: IOrder;
};

export const OrderEntryRmasPanel = (props: Props) => {
    return (
        <div className={"OrderEntryRmasPanel p-2"}>
            {props.order.RMAs?.length === 0 ? (
                <div>
                    <OwLabel title="no_rmas_found" />
                </div>
            ) : (
                (props.order.RMAs || []).map((rma) => (
                    <div key={rma.guid}>
                        <Link to={`/inventory/rma/${rma.guid}`}>{rma.rma_number}</Link>
                        <OwPill
                            title={rma.RMA_Status?.name || "Unknown"}
                            className={`ms-2 px-2 ${RmaService.getStatusBadgeColor(rma.rma_status_id)}`}
                        />
                    </div>
                ))
            )}
        </div>
    );
};
